import React from 'react';
import PropTypes from 'prop-types';

const FilterButton = ({ currentFilter, value, label, onClick }) => {
    const isActive = currentFilter === value;

    return (
        <button
            onClick={() => onClick(value)}
            className={`px-5 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform ${isActive
                ? 'bg-campus-primary text-white shadow-md scale-105'
                : 'bg-transparent text-campus-text-body hover:bg-campus-bg hover:scale-105'
                }`}
        >
            {label}
        </button>
    );
};

FilterButton.propTypes = {
    currentFilter: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default FilterButton;
